import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { useSelector } from 'react-redux';
import { Getstates } from '../../../../Axios/ServiceApi';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Box,
  Button,
  // Checkbox,
  // Divider,
  FormControl,
  // FormControlLabel,
  FormHelperText,
  Grid,
  Alert,
  Snackbar,
  // InputAdornment,
  InputLabel,
  OutlinedInput,

  // TextField,
  // Typography,
  // useMediaQuery
} from '@mui/material';

// third party
import * as Yup from 'yup';
import { Formik } from 'formik';

// project imports
import useScriptRef from 'hooks/useScriptRef';
// import Upload from 'assets/images/Image upload-bro.svg';
// import Google from 'assets/images/icons/social-google.svg';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { Stack } from '@mui/system';
import { UpiVerify } from '../../../../Axios/BankVerify';
// import Radio from '@mui/material/Radio';
// import RadioGroup from '@mui/material/RadioGroup';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import FormLabel from '@mui/material/FormLabel';
// import { IconUserPlus } from '@tabler/icons';
// import { Image } from '@mui/icons-material';
// import { strengthColor, strengthIndicator } from 'utils/password-strength';

// assets
// import Visibility from '@mui/icons-material/Visibility';
// import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { postUpiData } from '../../../../Axios/LimitAccountRegistration';

// ===========================|| FIREBASE - REGISTER ||=========================== //

const UpiRegister = () => {
  const theme = useTheme();
  const scriptedRef = useScriptRef();
  const [Verified, setVerified] = useState(false)
  const [ErrOpen, setErrOpen] = useState(false)
  const [ErrMessage, setErrMessage] = useState(null)
  const [ErrType, setErrType] = useState('success')
  const [openLoader, setOpenLoader] = useState(false)
  const [verifyResponse, setVerifyResponse] = useState(null)



  const [stateList, setStateList] = useState(null)
  useEffect(() => {
    Getstates(setStateList)
  }, [])

  console.log('States ', stateList);


  const handleErrClose = () => {
    setErrOpen(false)

  }

  return (
    <>
      {/*  */}
      <Snackbar open={ErrOpen} autoHideDuration={5000} onClose={handleErrClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert onClose={handleErrClose} variant='filled' severity={ErrType} sx={{ width: '100%' }}>
          {ErrMessage}
        </Alert>
      </Snackbar>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openLoader}
      >
        <CircularProgress
          color="inherit"
          variant="indeterminate"
          
        >
          
        </CircularProgress>
      </Backdrop>


      {/*  */}
      <Formik
        initialValues={{
          upi_id: '',

          // submit: null
        }}
        validationSchema={Yup.object().shape({
          upi_id: Yup.string().max(255).required('Upi id is required'),

        })}
        onSubmit={async (values, { setErrors, setStatus, setSubmitting, setFieldValue }) => {
          try {
            if (scriptedRef.current) {


              if (!Verified && !verifyResponse) {
                UpiVerify(values.upi_id, setErrMessage, setErrOpen, setVerified, setErrType, setOpenLoader, setVerifyResponse)
              }
              else {
                postUpiData(values.upi_id, verifyResponse.details.result.name_at_bank, setErrMessage, setErrOpen, setErrType, setVerified, setFieldValue, setVerifyResponse, setOpenLoader)
              }

            }
          } catch (err) {
            console.error('error ', err);
            if (scriptedRef.current) {
              setStatus({ success: false });
              setErrors({ submit: err.message });
              setSubmitting(false);
            }
          }
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values, isValid }) => (
          <form noValidate onSubmit={handleSubmit}>

            <Stack direction={{ xs: 'column', xl: 'row', lg: 'row', md: 'row', sm: 'row' }}>
              {/* <MapModal change={change} setChange={setChange} open={open} handleClose={handleClose} /> */}
              <Grid container spacing={1}>
                <Grid item xl={4}>
                  <FormControl fullWidth error={Boolean(touched.upi_id && errors.upi_id)} sx={{ ...theme.typography.customInput }}>
                    <InputLabel htmlFor="outlined-adornment-email-register">UPI Id</InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-email-register"
                      type="text"
                      fullWidth
                      value={values.upi_id}
                      name="upi_id"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      inputProps={{}}
                    />
                    {touched.upi_id && errors.upi_id && (
                      <FormHelperText error id="standard-weight-helper-text-address-register">
                        {errors.upi_id}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                <Grid item xl={4} sx={{ display: verifyResponse ? "inherit" : 'none' }}>
                  <FormControl fullWidth error={Boolean(touched.upi_id && errors.upi_id)} sx={{ ...theme.typography.customInput }}>
                    <InputLabel htmlFor="outlined-adornment-email-register">Name at bank</InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-email-register"
                      type="text"
                      fullWidth
                      value={verifyResponse ? verifyResponse.details.result.name_at_bank : ''}
                      onBlur={handleBlur}
                      disabled={true}
                      onChange={handleChange}
                      inputProps={{}}
                    />
                    {touched.upi_id && errors.upi_id && (
                      <FormHelperText error id="standard-weight-helper-text-address-register">
                        {errors.upi_id}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                {errors.submit && (
                  <Box sx={{ mt: 3 }}>
                    <FormHelperText error>{errors.submit}</FormHelperText>
                  </Box>
                )}
              </Grid>
            </Stack>
            <Grid container spacing={4}>

              <Grid item sm={6} xs={6}>
                <Box sx={{ mt: 2 }}>
                  <AnimateButton>
                    <Button
                      disableElevation
                      disabled={isSubmitting || !isValid}
                      fullWidth
                      size="large"
                      type="submit"
                      variant="contained"
                      sx={{ backgroundColor: Verified ? 'green' : '#A556B2', color: '#fff', "&:hover": { backgroundColor: "#A556B2" } }}

                    >
                      {!Verified ? 'Verify' : 'Submit'}
                    </Button>
                  </AnimateButton>
                </Box>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
      {/* image upload Dialog start */}
    </>
  );
};

export default UpiRegister;
